import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BuilderContext, useDrawer } from "react-flow-builder";

import {
  Form,
  Button,
  Input,
  Select,
  Checkbox,
  Alert,
  Empty,
  Space,
  Collapse,
  InputNumber,
  Radio,
} from "antd";
import {
  DeleteTwoTone,
  PlusOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { store } from "../../../../../../../redux";
import {
  setDraft,
  setVariablePanel,
  updateFormatedData,
} from "../../../../../../../redux/actions/skill";
import { notify } from "../../../../../../../redux/actions/snackActions";
import ReactTooltip from "react-tooltip";
import infoIcon from "../../../../../../../images/info-new.png";
import Zoom from "react-medium-image-zoom";
import { getCollections } from "../../../../../../../redux/actions/collections";
import { getCollectionsV2 } from "../../../../../../../redux/actions/collectionsV2";
import { IMPORT_TEMPLATE } from "../../../../../../../redux/constants/templateConstants";

const { Option } = Select;
const { Panel } = Collapse;
const VariableForm = (props) => {
  const dispatch = useDispatch();
  const skill = useSelector((state) => state.skillReducer);
  const [form] = Form.useForm();
  let [variables, setVariables] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isWaitLoading, setIsWaitLoading] = useState(false);
  const [isRetryLoading, setIsRetryLoading] = useState(false);
  const [collectionLoading, setCollectionLoading] = useState(false);
  const [checkAll, setCheckAll] = useState(true);
  const [collections, setCollections] = useState([]);
  const [waitTime, setWaitTime] = useState(60);
  const [retryCount, setRetryCount] = useState(5);

  const [panelOpen, setPanelOpen] = useState(false);
  const collectionName = useSelector(
    (state) => state.skillReducer?.trainDraft?.RAW_DATA?.collectionName
  );
  const globalWaitTime = useSelector(
    (state) => state.skillReducer?.trainDraft?.RAW_DATA?.gWaitTime
  );
  const globalRetryCount = useSelector(
    (state) => state.skillReducer?.trainDraft?.RAW_DATA?.gRetryCount
  );

  const userDetails = useSelector((state) => state.organizationReducer.currentOrganization);
  const groupPlan = useSelector((state) => state.userReducer.groupPlan);
  let planType;
  if((groupPlan?.planId == 4)){
    planType = "team";
  } else if((groupPlan?.planId == 5)){
    planType = "business";
  } else{
    planType = "pro";
  }

  let orgFilterFlag = false;
  try{
    const orgIdToFilterList = process.env?.REACT_APP_FILTERED_ORG_IDS_COLLECTION
                              ? JSON.parse(process.env.REACT_APP_FILTERED_ORG_IDS_COLLECTION)
                              : [];
    orgFilterFlag = orgIdToFilterList?.includes(JSON.parse(userDetails?.id));
  } catch{
    orgFilterFlag = false;
  }

  const [isPrivate, setIsPrivate] = useState(false);
  const [selectedCollection, setSelectedCollection] = useState(null);
  const handlePanelToggle = () => {
    setPanelOpen(!panelOpen);
  };
  const onChangeLLMType = (e) => {
    if (e.target.value == "private") {
      setIsPrivate(true);
    }
    if (e.target.value == "public") {
      setIsPrivate(false);
    }
  };
  function hasDuplicates(array) {
    const seen = {};
    for (const item of array) {
      if (seen[item]) {
        return true;
      }
      seen[item] = true;
    }
    return false;
  }
  const onFinish = async (values, section) => {
    if (section === "variables") {
    setIsLoading(true);
   } else if(section === "waitTime") {
    setIsWaitLoading(true);
    } else if (section === 'globalErrorRetry') {
    setIsRetryLoading(true);
    } else if (section === 'collections') {
      setCollectionLoading(true);
      }
    let {
      skillReducer: { trainDraft },
    } = store.getState();
    let validate = validateVariables();
    const existingVariableNames = variables.map((v) => v.name);
    
    if (hasDuplicates(existingVariableNames)) {
      setIsLoading(false);
      dispatch(notify("error", "Duplicate variable names are not allowed."));
      return;
    }
    if (validate == 0) {
      trainDraft.RAW_DATA?.actions.map((ele) => {
        variables.map((v) => {
          if (ele.id == v.id) {
            ele.text = v.value;
            ele.value = v.value;
          }
        });
      });
      await store.dispatch(
        setDraft({
          ...trainDraft,
          RAW_DATA: {
            ...trainDraft.RAW_DATA,
            variables: [...variables],
            collectionName: [selectedCollection],
            gWaitTime: waitTime,
            gRetryCount: retryCount,
          },
        })
      );
      let rawData = {
        ...trainDraft.RAW_DATA,
        variables: [...variables],
        collectionName: [selectedCollection],
        gWaitTime: waitTime,
        gRetryCount: retryCount,
      };
       let updatedData;
      if (trainDraft?.TEMPLATE == "Process Discovery") {
          updatedData = {
           status: trainDraft.status,
           skillName: trainDraft.SKILL_NAME,
           rawData,
           collectionName: [selectedCollection],
           itemId: trainDraft.id,
           gWaitTime: waitTime,
           gRetryCount: retryCount,
           variantId: trainDraft?.revision,
         };
      } else {
          updatedData = {
        status: trainDraft.status,
        skillName: trainDraft.SKILL_NAME,
        rawData,
        collectionName: [selectedCollection],
        itemId: trainDraft.id,
        gWaitTime: waitTime,
        gRetryCount: retryCount,
      };
      }
     
      await store.dispatch(updateFormatedData(updatedData));
      setIsLoading(false);
      setIsRetryLoading(false);
      setIsWaitLoading(false);
      setCollectionLoading(false);
      dispatch(notify("success", "Updated Succesfully!"));
      dispatch(setVariablePanel(false));
    } else {
      setIsLoading(false);
      setIsRetryLoading(false);
      setIsWaitLoading(false);
      setCollectionLoading(false);
      dispatch(
        notify(
          "error",
          "Invalid variable name. The use of '-' symbol and spaces are not allowed in variable names."
        )
      );

      return;
    }
  };

  useEffect(() => {
    setVariables([...(props.variables || [])]);
    setSelectedCollection(collectionName);
    setWaitTime(globalWaitTime ? globalWaitTime : 60);
    setRetryCount(globalRetryCount >=0 ? globalRetryCount : 5);
    if (collectionName && collectionName[0] != "ChatGPT") {
      setIsPrivate(true);
      setSelectedCollection(collectionName);
    } else {
      setIsPrivate(false);
      setSelectedCollection("ChatGPT");
    }
  }, [props]);

  useEffect(() => {
    let _verifyChecked = variables.filter((i) => i.reviewVariable == false);
    if (_verifyChecked.length == 0) {
      setCheckAll(true);
    }
    if (_verifyChecked.length == variables.length) {
      setCheckAll(false);
    }
  }, [variables]);

  const _add = () => {
    let ele = {
      name: "",
      value: "",
      dataType: "",
      editable: true,
      label: "",
      custom: true,
      reviewVariable: true,
    };
    variables.push(ele);
    setVariables([...variables]);
  };

  useEffect(() => {
    let _verifyChecked = variables.filter((i) => i.reviewVariable == false);
    if (_verifyChecked.length == 0) {
      setCheckAll(true);
    }
    if (_verifyChecked.length == variables.length) {
      setCheckAll(false);
    }
  }, [variables]);
  const _remove = (event, index) => {
    event.stopPropagation();
    variables.splice(index, 1);
    setVariables([...variables]);
  };

  const _update = (index, field, value) => {
    variables[index][field] = value;
    setVariables([...variables]);
  };

  const onChange = (index, field, value) => {
    variables[index][field] = value;
    setVariables([...variables]);
  };

  const validateVariables = () => {
    let error = 0;
    variables.length > 0 &&
      variables.forEach((v) => {
        if (v.name.includes("-") || v.name.includes(" ")) {
          error++;
        }
      });
    return error;
  };

  useEffect(() => {
    form.resetFields();
   }, [form, variables])

  const onChangeWaitTime = (value) => {
    setWaitTime(value);
  };

  const onChangeRetryCount = (value) => {
    setRetryCount(value);
  };

  const onCheckAllChange = (e) => {
    setCheckAll(e.target.checked);

    variables.forEach((v) => {
      v["reviewVariable"] = e.target.checked;
    });
    setVariables([...variables]);
  };

  const onChangeSelect = (value) => {
    setSelectedCollection(value);
  };
  const onSearchSelect = (value) => {};

  const SelectOptions = ({ collections }) => {
    return (
      <>
        <Select
          style={{ width: "100%" }}
          placeholder="Select Collection"
          onChange={onChangeSelect}
          value={selectedCollection}
          defaultValue={isPrivate == true ? "" : "ChatGPT"}
          options={collections.map((collection) => ({
            value: collection.name,
            label: orgFilterFlag ? collection.name : collection.name?.slice(collection.name.indexOf("_") + 1),
          }))}
        />
      </>
    );
  };
  const LLMType = () => {
    return (
      <div className="llmType">
        <Radio.Group
          onChange={onChangeLLMType}
          defaultValue={isPrivate == true ? "private" : "public"}
        >
          <Radio value="private">Private</Radio>
          <Radio value="public">Public</Radio>
        </Radio.Group>
      </div>
    );
  };

  const getCollectionsData = async () => {
    try {
      const data = orgFilterFlag ? await getCollections() : await getCollectionsV2();
      setCollections(data.response);
    } catch (err) {
      console.log("Error while retrieving", err.message);
    }
  };

  useEffect(() => {
    getCollectionsData();
  }, []);

  const items = [
    {
      key: "1",
      label: "ENABLE LLM",
      // children: <SelectOptions />,
      children: <LLMType />,
    },
  ];

  return (
    <>
      <Form
        form={form}
        name="dynamic_form_nest_item"
        //onFinish={onFinish}
        autoComplete="off"
      >
        <Form.List name="variables">
          {(_fields, { add, remove }) => (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  gap: "20px",
                }}
              >
                {/* <Form.Item style={{ width: "initial" }}>
                  <Button
                    type="primary"
                    className="btn btn-primary"
                    htmlType="submit"
                  >
                    {isLoading ? (
                      <div class="sp sp-circle text-light"></div>
                    ) : (
                      "Save"
                    )}
                  </Button>
                </Form.Item> */}
              </div>

              {variables.length > 0 ? (
                <div>
                  {/* <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-around",
                      gap:"15px"
                    }}
                  >
                    <ReactTooltip place="top" type="dark" effect="solid" />
                    <Checkbox
                      onChange={onCheckAllChange}
                      checked={checkAll}
                      data-tip="Check All"
                    ></Checkbox>
                    <h6 style={{ width: 150 }}>Variable name</h6>
                    <h6 style={{ width: 150 }}>Label</h6>
                    <h6 style={{ width: 150 }}>Data Type</h6>
                    <h6 style={{ width: 250 }}>Value</h6>
                  </div> */}
                  {/* {variables.map((item, index) => (
                    <Space
                      key={index}
                      style={{
                        display: "flex",
                        marginBottom: 8,
                        flexDirection: "row",
                        justifyContent: "space-around",
                      }}
                      align="baseline"
                    >
                      <Checkbox
                        defaultChecked={item.reviewVariable}
                        name="reviewVariable"
                        onChange={(e) =>
                          onChange(index, "reviewVariable", e.target.checked)
                        }
                        checked={item.reviewVariable}
                      ></Checkbox>
                      <Form.Item
                        initialValue={item.name}
                        fieldKey={index}
                        isListField={true}
                        name={[index, "name"]}
                        style={{ width: 150 }}
                        rules={[
                          { required: true, message: "Missing variable name" },
                        ]}
                        onBlur={(e) => _update(index, "name", e.target.value)}
                        onKeyDown={(e) =>
                          e.keyCode == 13 ? e.preventDefault() : ""
                        }
                      >
                        <Input
                          disabled={item?.editable ? false : true}
                          placeholder="Enter Variable name"
                        />
                      </Form.Item>

                      <Form.Item
                        initialValue={item.label}
                        fieldKey={index}
                        isListField={true}
                        name={[index, "label"]}
                        style={{ width: 150 }}
                        onBlur={(e) => _update(index, "label", e.target.value)}
                      >
                        <Input placeholder="Enter label" />
                      </Form.Item>

                      <Form.Item
                        isListField={true}
                        fieldKey={index}
                        name={[index, "dataType"]}
                        initialValue={item.dataType}
                        style={{ width: 150 }}
                        rules={[
                          { required: true, message: "Missing datatype name" },
                        ]}
                      >
                        <Select
                          disabled={item?.editable ? false : true}
                          style={{ width: 120 }}
                          onChange={(value) =>
                            _update(index, "dataType", value)
                          }
                        >
                          <Option value="number">Number</Option>
                          <Option value="string">String</Option>
                          <Option value="secure">Secure</Option>
                          <Option value="list">List</Option>
                          <Option value="dataTable">Data Table</Option>
                        </Select>
                      </Form.Item>

                      <Form.Item
                        initialValue={item.value}
                        isListField={true}
                        fieldKey={index}
                        name={[index, "value"]}
                        style={{ width: 250 }}
                        // rules={[
                        //   { required: true, message: "Missing variable value" },
                        // ]}
                        onBlur={(e) => _update(index, "value", e.target.value)}
                        onKeyDown={(e) =>
                          e.keyCode == 13 ? e.preventDefault() : ""
                        }
                      >
                        <Input placeholder="Enter Value" />
                      </Form.Item>
                      {item?.editable ? (
                        <DeleteTwoTone
                          disabled={item?.editable ? false : true}
                          onClick={() => _remove(index)}
                        />
                      ) : (
                        <DeleteTwoTone />
                      )}
                    </Space>
                  ))} */}

                  <Collapse
                    activeKey={panelOpen ? "1" : []}
                    onChange={handlePanelToggle}
                  >
                    <Panel header="Variables" key="1">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "end",
                          gap: "20px",
                        }}
                      >
                        <Form.Item style={{ width: "initial" }}>
                          <Button
                            shape="circle"
                            className="btn-add-plus"
                            onClick={(event) => _add(event)}
                          >
                            +
                          </Button>
                        </Form.Item>
                        <Form.Item style={{ width: "initial" }}>
                          <Button
                            type="primary"
                            className="btn btn-primary"
                            htmlType="submit"
                            onClick={(values) => onFinish(values, 'variables')}
                            
                          >
                            {isLoading ? (
                              <div class="sp sp-circle text-light"></div>
                            ) : (
                              "Save"
                            )}
                          </Button>
                        </Form.Item>
                      </div>
                      <table className="var-table">
                        <thead>
                          <tr>
                            <th style={{ width: "40px" }}>
                              <ReactTooltip
                                place="top"
                                type="dark"
                                effect="solid"
                              />

                              <Checkbox
                                onChange={onCheckAllChange}
                                checked={checkAll}
                                data-tip="Check All"
                              ></Checkbox>
                            </th>

                            <th>Variable Name</th>
                            <th>Label</th>
                            <th>Data Type</th>
                            <th>Value</th>
                            <th style={{ width: "40px" }}></th>
                          </tr>
                        </thead>
                        <tbody>
                          {variables.map((item,index) => (
                            <tr className="var-list-item">
                              <td style={{ width: "40px", textAlign: "left" }}>
                                <Checkbox
                                  initialValue={item.reviewVariable || false}
                                  name="reviewVariable"
                                  onChange={(e) =>
                                    onChange(
                                      index,
                                      "reviewVariable",
                                      e.target.checked
                                    )
                                  }
                                  checked={item.reviewVariable || false}
                                ></Checkbox>
                              </td>
                              <td className="flex-imgIp">
                                <Form.Item
                                  initialValue={item.name}
                                  fieldKey={index}
                                  isListField={true}
                                  name={[index, "name"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Missing variable name",
                                    },
                                  ]}
                                  onBlur={(e) =>
                                    _update(index, "name", e.target.value)
                                  }
                                  onKeyDown={(e) =>
                                    e.keyCode == 13 ? e.preventDefault() : ""
                                  }
                                >
                                  <Input
                                    disabled={item?.editable ? false : true}
                                    placeholder="Enter Variable name"
                                  />
                                </Form.Item>
                                <button
                                  className="btn-link dm-info fixed-info"
                                  type="button"
                                  data-toggle="dropdown"
                                >
                                  <img src={infoIcon} alt="" />
                                  <div className="popup-img modal-review-img">
                                    <Zoom>
                                      <img
                                        alt=""
                                        src={
                                          skill?.trainDraft?.FORMATED_DATA
                                            ?.actions[index]?.pageScreenshot
                                        }
                                      />
                                    </Zoom>
                                  </div>
                                </button>
                              </td>
                              <td>
                                <Form.Item
                                  initialValue={item.label}
                                  fieldKey={index}
                                  isListField={true}
                                  name={[index, "label"]}
                                  onBlur={(e) =>
                                    _update(index, "label", e.target.value)
                                  }
                                >
                                  <Input placeholder="Enter label" />
                                </Form.Item>
                              </td>
                              <td>
                                <Form.Item
                                  isListField={true}
                                  fieldKey={index}
                                  name={[index, "dataType"]}
                                  initialValue={item.dataType}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Missing datatype name",
                                    },
                                  ]}
                                >
                                  <Select
                                    disabled={item?.editable ? false : true}
                                    onChange={(value) =>
                                      _update(index, "dataType", value)
                                    }
                                  >
                                    <Option value="number">Number</Option>
                                    <Option value="string">String</Option>
                                    <Option value="secure">Secure</Option>
                                    <Option value="list">List</Option>
                                    <Option value="dataTable">
                                      Data Table
                                    </Option>
                                  </Select>
                                </Form.Item>
                              </td>
                              <td>
                                <Form.Item
                                  initialValue={item.value}
                                  isListField={true}
                                  fieldKey={index}
                                  name={[index, "value"]}
                                  // rules={[
                                  //   { required: true, message: "Missing variable value" },
                                  // ]}
                                  onBlur={(e) =>
                                    _update(index, "value", e.target.value)
                                  }
                                  onKeyDown={(e) =>
                                    e.keyCode == 13 ? e.preventDefault() : ""
                                  }
                                >
                                  <Input placeholder="Enter Value" />
                                </Form.Item>
                              </td>
                              <td  
                                style={{
                                  textAlign: "center",
                                  cursor: "pointer",
                                }}
                                onClick={(event) => _remove(event, index)}
                              >
                                {item?.editable ? (
                                  <DeleteTwoTone/>
                                ) : (
                                  null
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </Panel>
                  </Collapse>
                </div>
              ) : (
                <>
                  <div>
                    <Collapse
                      activeKey={panelOpen ? "1" : []}
                      onChange={handlePanelToggle}
                    >
                      <Panel header="Variables" key="1">
                        {/* <div style={{display: "flex",alignItems: "center",justifyContent: "end",gap: "20px"}}>
                    <Form.Item style={{ width: "initial" }}>
                        <Button
                          shape="circle"
                          className="btn-add-plus"
                          onClick={(event) => _add(event)}
                        >
                          +
                        </Button>
                      </Form.Item>
                    </div>                       */}
                        <Empty
                          style={{ padding: "30px" }}
                          image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                          imageStyle={{
                            height: 90,
                          }}
                          description={
                            <Button
                              className="btn btn-priamry"
                              type="primary"
                              onClick={(event) => _add(event)}
                            >
                              Create New Variable
                            </Button>
                          }
                          
                        >
                            <Form.Item style={{ width: "initial" }}>
                          <Button
                            type="primary"
                            className="btn btn-primary"
                            htmlType="submit"
                            onClick={(values) => onFinish(values, 'variables')}
                          >
                            {isLoading ? (
                              <div class="sp sp-circle text-light"></div>
                            ) : (
                              "Save"
                            )}
                          </Button>
                        </Form.Item>
                        </Empty>
                      </Panel>
                    </Collapse>
                  </div>
                </>
              )}
            </>
          )}
        </Form.List>
        {/* Collection for In-App Walkthrough */}
        {skill?.trainDraft?.TEMPLATE == "In-App Walkthrough" ? (
          <Collapse>
            {items.map((item) => (
              <Panel header={item.label} key={item.key}>
                <div className="d-flex input-save">
                  <LLMType />
                  {isPrivate ? (
                    <SelectOptions collections={collections} />
                  ) : (
                    <SelectOptions collections={[{ name: "ChatGPT" }]} />
                  )}
                  {/* <SelectOptions collections={collections} /> */}
                  <Form.Item style={{ width: "initial" }}>
                    <Button
                      type="primary"
                      className="btn btn-primary"
                      htmlType="submit"
                      onClick={(values) => onFinish(values, 'collections')}
                    >
                      {collectionLoading ? (
                        <div class="sp sp-circle text-light"></div>
                      ) : (
                        "Save"
                      )}
                    </Button>
                  </Form.Item>
                </div>
              </Panel>
            ))}
          </Collapse>
        ) : null}

        <Collapse>
          {/* Global wait time setting */}
          <Panel header={"Global Wait Time (in seconds)"}>
            <div className="d-flex input-save">
              <InputNumber
                className="timer-input"
                min={1}
                max={60}
                defaultValue={waitTime}
                onChange={onChangeWaitTime}
              />
              <Form.Item style={{ width: "initial" }}>
                <Button
                  type="primary"
                  className="btn btn-primary"
                  htmlType="submit"
                  onClick={(values) => onFinish(values, 'waitTime')}
                >
                  {isWaitLoading ? (
                    <div class="sp sp-circle text-light"></div>
                  ) : (
                    "Save"
                  )}
                </Button>
              </Form.Item>
            </div>
          </Panel>
        </Collapse>

        <Collapse>
          {/* Global wait time setting */}
          <Panel header={"Global Error Retry Max Limit"}>
            <div className="d-flex input-save">
              <InputNumber
                className="timer-input"
                min={0}
                max={10}
                defaultValue={retryCount}
                value={retryCount}
                onChange={onChangeRetryCount}
              />
              <Form.Item style={{ width: "initial" }}>
                <Button
                  type="primary"
                  className="btn btn-primary"
                  htmlType="submit"
                  onClick={(values) => onFinish(values, 'globalErrorRetry')}
                >
                  {isRetryLoading ? (
                    <div class="sp sp-circle text-light"></div>
                  ) : (
                    "Save"
                  )}
                </Button>
              </Form.Item>
            </div>
          </Panel>
        </Collapse>
      </Form>
    </>
  );
};

export default VariableForm;
